var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatteryPluggedInNotCharging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2400,
    height: 2400,
    viewBox: "0 0 2400 2400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M780.691 600H300V1800H976.228V1727.08H969.048C754.437 1727.08 590 1515.46 590 1252.63V672.648H780.691V600Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.49 1800H1900V1400H2100V1000H1900V600H1453.02V672.648H1643.71V1252.63C1643.71 1515.46 1479.28 1727.08 1264.67 1727.08H1257.49V1800Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.69 600V672.648H1062.02V600H1171.69Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1360.05 786.933V400H1264.67V786.933H969.048V400H873.666V786.933H682.975V1252.63C682.975 1459.39 811.332 1612.8 969.048 1612.8H1069.2V2000H1164.51V1612.8H1264.67C1422.38 1612.8 1550.74 1459.39 1550.74 1252.63V786.933H1360.05ZM1455.36 1252.63C1455.36 1390.5 1369.81 1502.68 1264.67 1502.68H969.048C863.904 1502.68 778.357 1390.5 778.357 1252.63V912H1455.36V1252.63Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryPluggedInNotCharging);
export default __webpack_public_path__ + "static/media/battery-plugged-in-not-charging.fa7c03d1ed0f81a8ff6a1516b4f2d2a0.svg";
export { ForwardRef as ReactComponent };